// extracted by mini-css-extract-plugin
export default {"bio":"J6","about":"K6","title":"L6","text":"M6","fun_facts":"N6","fun":"O6","icon":"P6","bio_header":"Q6"};
    if(module.hot) {
      // 1737143664967
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  